const map = {
	"./female/B1.aac": 7494,
	"./female/B10.aac": 3320,
	"./female/B11.aac": 7609,
	"./female/B12.aac": 9966,
	"./female/B13.aac": 3375,
	"./female/B14.aac": 8460,
	"./female/B15.aac": 4205,
	"./female/B2.aac": 2673,
	"./female/B3.aac": 7264,
	"./female/B4.aac": 8011,
	"./female/B5.aac": 8778,
	"./female/B6.aac": 6309,
	"./female/B7.aac": 5940,
	"./female/B8.aac": 9167,
	"./female/B9.aac": 4878,
	"./female/G46.aac": 3948,
	"./female/G47.aac": 9693,
	"./female/G48.aac": 5286,
	"./female/G49.aac": 2759,
	"./female/G50.aac": 8541,
	"./female/G51.aac": 3100,
	"./female/G52.aac": 5555,
	"./female/G53.aac": 6834,
	"./female/G54.aac": 5529,
	"./female/G55.aac": 5624,
	"./female/G56.aac": 8879,
	"./female/G57.aac": 8478,
	"./female/G58.aac": 2101,
	"./female/G59.aac": 2132,
	"./female/G60.aac": 544,
	"./female/I16.aac": 7933,
	"./female/I17.aac": 268,
	"./female/I18.aac": 4695,
	"./female/I19.aac": 3782,
	"./female/I20.aac": 9462,
	"./female/I21.aac": 8471,
	"./female/I22.aac": 2400,
	"./female/I23.aac": 8289,
	"./female/I24.aac": 3674,
	"./female/I25.aac": 1403,
	"./female/I26.aac": 6244,
	"./female/I27.aac": 821,
	"./female/I28.aac": 1022,
	"./female/I29.aac": 4575,
	"./female/I30.aac": 9285,
	"./female/N31.aac": 3843,
	"./female/N32.aac": 7932,
	"./female/N33.aac": 3677,
	"./female/N34.aac": 9438,
	"./female/N35.aac": 2847,
	"./female/N36.aac": 2792,
	"./female/N37.aac": 7081,
	"./female/N38.aac": 554,
	"./female/N39.aac": 6747,
	"./female/N40.aac": 783,
	"./female/N41.aac": 9758,
	"./female/N42.aac": 201,
	"./female/N43.aac": 4056,
	"./female/N44.aac": 9875,
	"./female/N45.aac": 1762,
	"./female/O61.aac": 2089,
	"./female/O62.aac": 5038,
	"./female/O63.aac": 5439,
	"./female/O64.aac": 9660,
	"./female/O65.aac": 5101,
	"./female/O66.aac": 3394,
	"./female/O67.aac": 2115,
	"./female/O68.aac": 8640,
	"./female/O69.aac": 3793,
	"./female/O70.aac": 2559,
	"./female/O71.aac": 2190,
	"./female/O72.aac": 3321,
	"./female/O73.aac": 8328,
	"./female/O74.aac": 2435,
	"./female/O75.aac": 8354,
	"./male/B1.aac": 8939,
	"./male/B10.aac": 7435,
	"./male/B11.aac": 618,
	"./male/B12.aac": 5909,
	"./male/B13.aac": 7620,
	"./male/B14.aac": 7159,
	"./male/B15.aac": 2982,
	"./male/B2.aac": 1700,
	"./male/B3.aac": 1669,
	"./male/B4.aac": 294,
	"./male/B5.aac": 4071,
	"./male/B6.aac": 8000,
	"./male/B7.aac": 6801,
	"./male/B8.aac": 6402,
	"./male/B9.aac": 5123,
	"./male/G46.aac": 9199,
	"./male/G47.aac": 8942,
	"./male/G48.aac": 5445,
	"./male/G49.aac": 9300,
	"./male/G50.aac": 3246,
	"./male/G51.aac": 9951,
	"./male/G52.aac": 2424,
	"./male/G53.aac": 6441,
	"./male/G54.aac": 2450,
	"./male/G55.aac": 7027,
	"./male/G56.aac": 4764,
	"./male/G57.aac": 7485,
	"./male/G58.aac": 8278,
	"./male/G59.aac": 6103,
	"./male/G60.aac": 9031,
	"./male/I16.aac": 5030,
	"./male/I17.aac": 9207,
	"./male/I18.aac": 7868,
	"./male/I19.aac": 4237,
	"./male/I20.aac": 3313,
	"./male/I21.aac": 7424,
	"./male/I22.aac": 3495,
	"./male/I23.aac": 8134,
	"./male/I24.aac": 5845,
	"./male/I25.aac": 4916,
	"./male/I26.aac": 75,
	"./male/I27.aac": 2346,
	"./male/I28.aac": 2937,
	"./male/I29.aac": 968,
	"./male/I30.aac": 9250,
	"./male/N31.aac": 7940,
	"./male/N32.aac": 11,
	"./male/N33.aac": 778,
	"./male/N34.aac": 4673,
	"./male/N35.aac": 9264,
	"./male/N36.aac": 6711,
	"./male/N37.aac": 9494,
	"./male/N38.aac": 1741,
	"./male/N39.aac": 7692,
	"./male/N40.aac": 7780,
	"./male/N41.aac": 6069,
	"./male/N42.aac": 8397,
	"./male/N43.aac": 7595,
	"./male/N44.aac": 816,
	"./male/N45.aac": 5281,
	"./male/O61.aac": 1886,
	"./male/O62.aac": 4409,
	"./male/O63.aac": 6120,
	"./male/O64.aac": 6547,
	"./male/O65.aac": 1346,
	"./male/O66.aac": 6749,
	"./male/O67.aac": 2700,
	"./male/O68.aac": 1719,
	"./male/O69.aac": 4502,
	"./male/O70.aac": 2504,
	"./male/O71.aac": 2905,
	"./male/O72.aac": 5502,
	"./male/O73.aac": 5759,
	"./male/O74.aac": 9980,
	"./male/O75.aac": 2269,
	"./oromo/B1.aac": 1454,
	"./oromo/B10.aac": 2688,
	"./oromo/B11.aac": 1489,
	"./oromo/B12.aac": 4982,
	"./oromo/B13.aac": 8759,
	"./oromo/B14.aac": 2740,
	"./oromo/B15.aac": 6357,
	"./oromo/B2.aac": 8857,
	"./oromo/B3.aac": 8456,
	"./oromo/B4.aac": 4707,
	"./oromo/B5.aac": 434,
	"./oromo/B6.aac": 8221,
	"./oromo/B7.aac": 5932,
	"./oromo/B8.aac": 983,
	"./oromo/B9.aac": 1030,
	"./oromo/G46.aac": 5012,
	"./oromo/G47.aac": 2741,
	"./oromo/G48.aac": 9886,
	"./oromo/G49.aac": 7263,
	"./oromo/G50.aac": 8677,
	"./oromo/G51.aac": 6708,
	"./oromo/G52.aac": 3227,
	"./oromo/G53.aac": 7034,
	"./oromo/G54.aac": 1537,
	"./oromo/G55.aac": 368,
	"./oromo/G56.aac": 3223,
	"./oromo/G57.aac": 5750,
	"./oromo/G58.aac": 3805,
	"./oromo/G59.aac": 8060,
	"./oromo/G60.aac": 9816,
	"./oromo/I16.aac": 9125,
	"./oromo/I17.aac": 9156,
	"./oromo/I18.aac": 5903,
	"./oromo/I19.aac": 3121,
	"./oromo/I20.aac": 5918,
	"./oromo/I21.aac": 207,
	"./oromo/I22.aac": 152,
	"./oromo/I23.aac": 8441,
	"./oromo/I24.aac": 5378,
	"./oromo/I25.aac": 2960,
	"./oromo/I26.aac": 3084,
	"./oromo/I27.aac": 781,
	"./oromo/I28.aac": 8534,
	"./oromo/I29.aac": 5751,
	"./oromo/I30.aac": 6509,
	"./oromo/N31.aac": 7675,
	"./oromo/N32.aac": 4212,
	"./oromo/N33.aac": 1525,
	"./oromo/N34.aac": 3238,
	"./oromo/N35.aac": 4375,
	"./oromo/N36.aac": 9456,
	"./oromo/N37.aac": 8417,
	"./oromo/N38.aac": 706,
	"./oromo/N39.aac": 8435,
	"./oromo/N40.aac": 7063,
	"./oromo/N41.aac": 9638,
	"./oromo/N42.aac": 6145,
	"./oromo/N43.aac": 992,
	"./oromo/N44.aac": 8283,
	"./oromo/N45.aac": 3706,
	"./oromo/O61.aac": 7345,
	"./oromo/O62.aac": 2166,
	"./oromo/O63.aac": 7527,
	"./oromo/O64.aac": 5300,
	"./oromo/O65.aac": 9877,
	"./oromo/O66.aac": 6378,
	"./oromo/O67.aac": 459,
	"./oromo/O68.aac": 5000,
	"./oromo/O69.aac": 6969,
	"./oromo/O70.aac": 9591,
	"./oromo/O71.aac": 5414,
	"./oromo/O72.aac": 1201,
	"./oromo/O73.aac": 6736,
	"./oromo/O74.aac": 3515,
	"./oromo/O75.aac": 6698
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;